import "./App.css";
import { useEffect, useState, useRef } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Sidebar from "./Sidebar/sidebar";
import Notification from "./Notification/Notification";

import { pageComponents, preloadPage } from './utils/pageLoader';
import { clearInventoryReads } from './utils/inventoryReadClient';
// PAGES

import UnderMaintenancePage from "./pages/UnderMaintenancePage";

import AdminLoginPage from "./Login/AdminLoginPage";
import PRNotification from "./PurchaseRequest/PRNotification";
import MRNotification from "./Materialrequestform/MRNotification";

import PONotification from "./PurchaseOrder/Ponotification";

import API_BASE_URL from "./config";

// ======================
const { ModernGlassDashboard, PurchaseRequisitionUI, ReferenceCards, DepartmentPage, CompanyPage, LocationPage, VendorPage, ShippingInformation, ExpenseTypePage, UserLevelPage, UserManagement, PaymentMethodsPage, MyRequestsPage, PurchaseOrder, PurchaseOrdersPage, POReceiving, POInvoiceTransmittal, PRApproval, POApproval, PRApprovalHistory, POApprovalHistory, PO_Reports, PR_Reports, PositionLevelAccess, MyProfile, Settingss, LicenseSelectionPage, ApproverPositionManagement, ChangePasswordPage, Website_status_maintenance, InventoryDestinationManager, InventoryDistribution, WebsiteInfoPage, ItemMaintenance, ItemUomConversion, BatchMaintenance, SecondPR_Approval, GoodsReceipt, WarehousePage, GRViewList, BatchNumberPage, InventoryList, StockAdjustmentList, StockAdjustmentForm, MaterialRequestForm, ItemRequestFormPending, GoodIssue, MaterialRequestApproval, PrPoTagsItem, LicenseManagement, RmReports, FuelRequisitionList, FuelRequisitionForm, ReturnRequestList, FuelRequisitionApproval, ShipToShipRequestViewer, MRFolderByDate, Logs, NotificationConfig, PRPOManual, NotificationSettings, QuotationView, TruckPage, Gatepass, FuelHistory, ReceivingReports, Requestor, QuotationApp, CollectionReceipt, ScrapCodesPage, ScrapLoadingForm, ProductionScrap, SalesOrder, DisposalApproval, Disposal_Form, CombinedDashboard, MotorpoolScrap, LPNGenerate, ReferenceCardAccess, Rackings_Inventory, ItemRequestApprovalReleasedBy, Marketing_Itemsmaintenance, CustomerMaintenance, Inventory_Marketing_PAGE, SO_Marketing_FORM, GR_Marketing_LIST, GR_Marketing_FORM, GR_Marketing_Posted_History, FG_Withdrawal_FORM_LIST, FG_Withdrawal_FORM, SO_Marketing_LIST, AccountingSystemSettings, ItemDirect, Fuel_diesel, FuelMonitor, GasmanList, ModuleHub, RrImportChina, RrLocal, Trucktoolsform, BorrowingForm, SalaryDeductionForm } = pageComponents;
// PROTECTED DASHBOARD
// ======================
function DashboardRoute() {
  return <MainApp />;
}

function MainApp() {
  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem("isLoggedIn") === "true"
  );

  const [currentPage, setCurrentPageState] = useState(
    localStorage.getItem("currentPage") || "dashboard"
  );

  const navigationRequest = useRef(0);
  useEffect(() => () => { navigationRequest.current++; }, []);
  const setCurrentPage = async (page) => {
    const next = typeof page === 'function' ? page(currentPage) : page;
    const request = ++navigationRequest.current;
    try {
      await preloadPage(next);
      if (request === navigationRequest.current) setCurrentPageState(next);
    } catch (error) {
      if (request !== navigationRequest.current) return;
      console.error('Unable to load page:', error);
      window.alert('Unable to load this page. Please try again.');
    }
  };

  // Context passed between pages (e.g. GRViewList → BatchNumberPage)
  const [pageParams, setPageParams] = useState({});

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [websiteStatus, setWebsiteStatus] = useState(null);
  const [checkingStatus, setCheckingStatus] = useState(true);

  // ✅ Detect mobile — sidebar should overlay on mobile, not push content
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ PALITAN ITO — same pattern as sa ItemDirect mo
  const getCurrentUser = () => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); }
    catch { return {}; }
  };

  const user = getCurrentUser();
  const userPosition = user.role || user.userRole || user.roleName || '';
  // SAVE CURRENT PAGE
  useEffect(() => {
    localStorage.setItem("currentPage", currentPage);
  }, [currentPage]);

  // WEBSITE STATUS
  useEffect(() => {
    const fetchWebsiteStatus = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}api/Website/1`);
        if (res.ok) setWebsiteStatus(await res.json());
      } catch (err) {
        console.error(err);
      } finally {
        setCheckingStatus(false);
      }
    };

    fetchWebsiteStatus();
    const interval = setInterval(fetchWebsiteStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleLoginSuccess = async () => {
    try {
      await preloadPage(currentPage);
      sessionStorage.setItem("isLoggedIn", "true");
      setIsLoggedIn(true);
    } catch (error) {
      console.error('Unable to load page:', error);
      window.alert('Unable to load this page. Please try again.');
    }
  };

  if (!isLoggedIn) {
    return <AdminLoginPage onLogin={handleLoginSuccess} />;
  }

  const isSystemAdmin = userPosition === "SYSTEM ADMIN";

  if (
    !checkingStatus &&
    websiteStatus?.website_Status === false &&
    !isSystemAdmin &&
    currentPage !== "Website"
  ) {
    return <UnderMaintenancePage />;
  }

  // ✅ KEY FIX: On mobile, sidebar overlays (no marginLeft)
  // On desktop, sidebar is fixed 256px so main needs marginLeft
  const getMainContentStyles = () => {
    const sidebarPosition = localStorage.getItem("sidebarPosition") || "left";
    const isHorizontal = sidebarPosition === "top" || sidebarPosition === "bottom";

    // Mobile: always full width, no margin (sidebar overlays)
    if (isMobile) {
      return {
        flex: 1,
        width: "100%",
        minHeight: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        // Add top padding if sidebar is on top (horizontal mobile)
        paddingTop: sidebarPosition === "top" ? "64px" : "0",
        paddingBottom: sidebarPosition === "bottom" ? "64px" : "0",
        transition: "all 0.3s ease",
      };
    }

    // Desktop horizontal (top/bottom)
    if (isHorizontal) {
      return {
        flex: 1,
        minHeight: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        paddingTop: sidebarPosition === "top" ? "64px" : "0",
        paddingBottom: sidebarPosition === "bottom" ? "64px" : "0",
        transition: "all 0.3s ease",
      };
    }

    // Desktop vertical — only add margin if sidebar is NOT collapsed
    if (sidebarCollapsed) {
      return {
        flex: 1,
        minHeight: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        transition: "all 0.3s ease",
      };
    }

    return {
      flex: 1,
      minHeight: "100vh",
      overflowY: "auto",
      overflowX: "hidden",
      marginLeft: sidebarPosition === "left" ? "256px" : "0",
      marginRight: sidebarPosition === "right" ? "256px" : "0",
      transition: "all 0.3s ease",
    };
  };

  const handleLogout = () => {
    navigationRequest.current++;
    clearInventoryReads();
    setIsLoggedIn(false);
    sessionStorage.removeItem("isLoggedIn");
    localStorage.removeItem("currentPage");
  };

  const renderPage = () => {
    switch (currentPage) {
      case "dashboard": return <ModernGlassDashboard />;
      case "CreatePO": return <PurchaseRequisitionUI setCurrentPage={setCurrentPage} />;
      case "referencess": return <ReferenceCards setCurrentPage={setCurrentPage} />;
      case "department": return <DepartmentPage setCurrentPage={setCurrentPage} />;
      case "companyPage": return <CompanyPage setCurrentPage={setCurrentPage} />;
      case "locationPage": return <LocationPage setCurrentPage={setCurrentPage} />;
      case "vendorPage": return <VendorPage setCurrentPage={setCurrentPage} />;
      case "shippingInformation": return <ShippingInformation setCurrentPage={setCurrentPage} />;
      case "expenseTypePage": return <ExpenseTypePage setCurrentPage={setCurrentPage} />;
      case "userLevelPage": return <UserLevelPage setCurrentPage={setCurrentPage} />;
      case "UserManagement": return <UserManagement setCurrentPage={setCurrentPage} />;
      case "PaymentMethodsPage": return <PaymentMethodsPage setCurrentPage={setCurrentPage} />;
      case "PurchaseRequests": return <MyRequestsPage setCurrentPage={setCurrentPage} />;
      case "PurchaseOrder": return <PurchaseOrder setCurrentPage={setCurrentPage} />;
      case "PurchaseOrdersPage": return <PurchaseOrdersPage setCurrentPage={setCurrentPage} />;
      case "POReceiving": return <POReceiving setCurrentPage={setCurrentPage} />;
      case "POInvoiceTransmittal": return <POInvoiceTransmittal setCurrentPage={setCurrentPage} />;
      case "PRApproval": return <PRApproval setCurrentPage={setCurrentPage} />;
      case "POApproval": return <POApproval setCurrentPage={setCurrentPage} />;
      case "PRApprovalHistory": return <PRApprovalHistory setCurrentPage={setCurrentPage} />;
      case "POApprovalHistory": return <POApprovalHistory setCurrentPage={setCurrentPage} />;
      case "PO_Reports": return <PO_Reports setCurrentPage={setCurrentPage} />;
      case "PR_Reports": return <PR_Reports setCurrentPage={setCurrentPage} />;
      case "PositionLevelAccess": return <PositionLevelAccess setCurrentPage={setCurrentPage} />;
      case "MyProfile": return <MyProfile setCurrentPage={setCurrentPage} />;
      case "Settingss": return <Settingss setCurrentPage={setCurrentPage} />;
      case "LicenseSelectionPage": return <LicenseSelectionPage setCurrentPage={setCurrentPage} />;
      case "ApproverPositionManagement": return <ApproverPositionManagement setCurrentPage={setCurrentPage} />;
      case "ChangePassword": return <ChangePasswordPage setCurrentPage={setCurrentPage} />;
      case "Website": return <Website_status_maintenance setCurrentPage={setCurrentPage} />;
      case "InventoryDestinationManager": return <InventoryDestinationManager setCurrentPage={setCurrentPage} />;
      case "InventoryDistribution": return <InventoryDistribution setCurrentPage={setCurrentPage} />;
      case "WebsiteInformation": return <WebsiteInfoPage setCurrentPage={setCurrentPage} />;
      case "ItemMaintenance": return <ItemMaintenance setCurrentPage={setCurrentPage} />;
      case "ItemUomConversion": return <ItemUomConversion setCurrentPage={setCurrentPage} />;
      case "BatchMaintenance": return <BatchMaintenance setCurrentPage={setCurrentPage} />;
      case "SecondPR_Approval": return <SecondPR_Approval setCurrentPage={setCurrentPage} />;
      case "GoodsReceipt": return <GoodsReceipt setCurrentPage={setCurrentPage} />;
      case "Requestor": return <Requestor setCurrentPage={setCurrentPage} />;
      case "WarehousePage": return <WarehousePage setCurrentPage={setCurrentPage} />;
      case "GRViewList": return <GRViewList setCurrentPage={setCurrentPage} setPageParams={setPageParams} />;
      case "BatchNumber": return <BatchNumberPage setCurrentPage={setCurrentPage} pageParams={pageParams} />;
      case "InventoryList": return <InventoryList setCurrentPage={setCurrentPage} />;
      case "StockAdjustmentList": return <StockAdjustmentList setCurrentPage={setCurrentPage} />;
      case "StockAdjustmentForm": return <StockAdjustmentForm setCurrentPage={setCurrentPage} />;
      case "ItemRequestForm": return <MaterialRequestForm setCurrentPage={setCurrentPage} />;
      case "ItemRequestFormPending": return <ItemRequestFormPending setCurrentPage={setCurrentPage} />;
      case "ReturnRequestList": return <ReturnRequestList setCurrentPage={setCurrentPage} />;
      case "ItemRequestApproval": return <MaterialRequestApproval setCurrentPage={setCurrentPage} />;
      case "LicenseManagement": return <LicenseManagement setCurrentPage={setCurrentPage} />;
      case "IRReports": return <RmReports setCurrentPage={setCurrentPage} />;
      case "FuelRequestForm": return <FuelRequisitionForm setCurrentPage={setCurrentPage} />;
      case "FuelRequisitionList": return <FuelRequisitionList setCurrentPage={setCurrentPage} />;
      case "FuelRequisitionApproval": return <FuelRequisitionApproval setCurrentPage={setCurrentPage} />;
      case "ShipToShipRequestViewer": return <ShipToShipRequestViewer setCurrentPage={setCurrentPage} />;
      case "MRFolderByDate": return <MRFolderByDate setCurrentPage={setCurrentPage} />;
      case "Notification": return <NotificationConfig setCurrentPage={setCurrentPage} />;
      case "PRPOManual": return <PRPOManual setCurrentPage={setCurrentPage} />;
      case "NotificationSettings": return <NotificationSettings setCurrentPage={setCurrentPage} />;
      case "CombinedDashboard": return <CombinedDashboard setCurrentPage={setCurrentPage} />;
      case "Quotation": return <QuotationApp setCurrentPage={setCurrentPage} />;
      case "QuotationView": return <QuotationView setCurrentPage={setCurrentPage} />;
      case "Gatepass": return <Gatepass setCurrentPage={setCurrentPage} />;
      case "Truck": return <TruckPage setCurrentPage={setCurrentPage} />;
      case "FuelHistory": return <FuelHistory setCurrentPage={setCurrentPage} />;
      case "ReceivingReports": return <ReceivingReports setCurrentPage={setCurrentPage} />;
      case "Disposal_Form": return <Disposal_Form setCurrentPage={setCurrentPage} />;
      case "DisposalApproval": return <DisposalApproval setCurrentPage={setCurrentPage} />;
      case "Motorpool_Scrap": return <MotorpoolScrap setCurrentPage={setCurrentPage} />;
      case "Scrap_Loding_Form": return <ScrapLoadingForm setCurrentPage={setCurrentPage} />;
      case "ScrapCodesPage": return <ScrapCodesPage setCurrentPage={setCurrentPage} />;
      case "LPNGenerate": return <LPNGenerate setCurrentPage={setCurrentPage} />;

      case "GoodIssue": return <GoodIssue setCurrentPage={setCurrentPage} />;

      case "AccountingSystemSettings": return <AccountingSystemSettings setCurrentPage={setCurrentPage} />;

      case "GasmanList": return <GasmanList setCurrentPage={setCurrentPage} />;

      case "ReferenceCardAccess": return <ReferenceCardAccess setCurrentPage={setCurrentPage} />;

      case "FG_Withdrawal_FORM": return <FG_Withdrawal_FORM setCurrentPage={setCurrentPage} />;
      case "FG_Withdrawal_FORM_LIST": return <FG_Withdrawal_FORM_LIST setCurrentPage={setCurrentPage} />;
      case "GR_Marketing_FORM": return <GR_Marketing_FORM setCurrentPage={setCurrentPage} />;
      case "GR_Marketing_LIST": return <GR_Marketing_LIST setCurrentPage={setCurrentPage} />;
      case "GR_Marketing_Posted_History": return <GR_Marketing_Posted_History setCurrentPage={setCurrentPage} />;
      case "SO_Marketing_FORM": return <SO_Marketing_FORM setCurrentPage={setCurrentPage} />;
      case "Inventory_Marketing_PAGE": return <Inventory_Marketing_PAGE setCurrentPage={setCurrentPage} />;
      case "CustomerMaintenance": return <CustomerMaintenance setCurrentPage={setCurrentPage} />;
      case "SO_Marketing_LIST": return <SO_Marketing_LIST setCurrentPage={setCurrentPage} />;

      case "Marketing_Itemsmaintenance": return <Marketing_Itemsmaintenance setCurrentPage={setCurrentPage} />;
      case "FuelMonitor": return <FuelMonitor setCurrentPage={setCurrentPage} />;
      case "ItemRequestApprovalReleasedBy": return <ItemRequestApprovalReleasedBy setCurrentPage={setCurrentPage} />;
      case "Fuel_diesel": return <Fuel_diesel setCurrentPage={setCurrentPage} />;
      case "Rackings_Inventory": return <Rackings_Inventory setCurrentPage={setCurrentPage} />;
      case "ItemDirect": return <ItemDirect setCurrentPage={setCurrentPage} />;

      case "Collection_Receipt": return <CollectionReceipt setCurrentPage={setCurrentPage} />;

      case "Sales_Order_Scrap": return <SalesOrder setCurrentPage={setCurrentPage} />;

      case "RrImportChina": return <RrImportChina setCurrentPage={setCurrentPage} />;
      case "RrLocal": return <RrLocal setCurrentPage={setCurrentPage} />;
      case "Trucktoolsform": return <Trucktoolsform setCurrentPage={setCurrentPage} />;
      case "BorrowingForm": return <BorrowingForm setCurrentPage={setCurrentPage} />;
      case "SalaryDeductionForm": return <SalaryDeductionForm setCurrentPage={setCurrentPage} />;

      case "ModuleHub": return <ModuleHub setCurrentPage={setCurrentPage} />;

      
      
      case "Production_Scrap": return <ProductionScrap setCurrentPage={setCurrentPage} />;
      case "Logs": return <Logs setCurrentPage={setCurrentPage} />;
      default: return <ModernGlassDashboard />;
    }
  };

  return (
    // ✅ Remove overflow-hidden on mobile so content scrolls properly
    <div className={`App ${isMobile ? "flex flex-col" : "flex"} min-h-screen`}>
      <Sidebar
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        onLogout={handleLogout}
      />
      {/* ✅ Main content — takes full width on mobile */}
      <main style={getMainContentStyles()}>
        {renderPage()}
      </main>
      <Notification />
      <MRNotification />   {/* ← DAGDAG ITO */}
      <PRNotification />
      <PONotification />

    </div>
  );
}

// ======================
// ROUTES
// ======================
export function App() {
  return (
    <Routes>
      <Route path="/" element={<DashboardRoute />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
